import React, { Component, useRef } from "react";
import {
  Row,
  Col,
  Alert,
  Button,
  Container,
  FormGroup,
  Label,
} from "reactstrap";
import { connect, useDispatch } from "react-redux";
import { withRouter, Link } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import {
  forgetUser,
  clearStore,
  resetPasswordForgot,
} from "../../store/actions";
import logodark from "../../assets/images/logo-main.jpg";
import { makeStyles } from "@mui/styles";
import { commonStyles } from '../../theme';
import { useState } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import EncryptPassword from "../EncryptPassword";
import {
  InputAdornment,
  IconButton,
  TextField
} from "@mui/material";
import {
  Visibility as VisibilityIcon,
  VisibilityOff as VisibilityOffIcon
} from "@mui/icons-material";

const useStyles = makeStyles((theme) => ({
  ...commonStyles,
  // Add any component-specific styles here
}));

const PasswordResetPage = () => {
  const location = useLocation();
  const { state } = location;
  let email;
  if (state && state.email) {
    email = state.email;
    // Do something with the passed email value
    // console.log("Received Email:", email);
  }
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  // const [verificationCode, setVerificationCode] = useState("");
  const [verificationCode, setVerificationCode] = useState(['', '', '', '', '', '']);
  const verificationCodeRefs = useRef([]);
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [passwordError1, setPasswordError1] = useState(false);
  const [passwordErrorBoth, setPasswordErrorBoth] = useState(false);
  const [detailedErr, setDetailedErr] = useState("");
  const [submit, setSubmit] = useState(false);
  const [verificationCodeEntered, setVerificationCodeEntered] = useState(false);
  const reset = useSelector((state) => {
    return state.forgetPassword;
  });
  // var success = false;
  const { loading, resetSuccess, resetError } = reset;
  // const regex = /^(?=.[a-z])(?=.[A-Z])(?=.*\d)[a-zA-Z\d]{8,}$/
  // const regex = /^(?=.\d)(?=.[a-z])(?=.[A-Z])[0-9a-zA-Z!@#$%^&?]{8,}$/;
  // const regex = /^(?!.*\s)(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~])[A-Za-z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]{8,}$/;
  const dispatch = useDispatch();
  //reset error in here

  // function handleSubmit() {
  //   // dispatch(resetPasswordForgot({ password: password1, token: token.token }));
  // }

  // function handleChangePassword(){
  //     setPassword1(password)
  // }
  function handleClickShowPassword1() {
    setShowPassword1(!showPassword1);
  }
  function handleClickShowPassword2() {
    setShowPassword2(!showPassword2);
  }
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  // const handleChange = (index, event) => {
  //   const updatedVerificationCode = [...verificationCode];
  //   updatedVerificationCode[index] = event.target.value;
  //   setVerificationCode(updatedVerificationCode);
  // };

  const handleDigitChange = (index, event) => {
    const { value } = event.target;
    
    // Only allow numbers
    const numericValue = value.replace(/[^0-9]/g, '');

    if (numericValue.length <= 1) {
      const updatedVerificationCode = [...verificationCode];
      updatedVerificationCode[index] = numericValue;
      setVerificationCode(updatedVerificationCode);

      if (
        numericValue.length === 1 &&
        index < verificationCodeRefs.current.length - 1
      ) {
        verificationCodeRefs.current[index + 1].focus();
      }
    }
  };

  // console.log("Email = ", email);
  useEffect(() => {
    const regex = /^(?!.*\s)(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~])[A-Za-z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]{8,}$/;
    setSubmit(false);
    if (password1 != "") {
      if (!regex.test(password1)) {
        setPasswordError1(true);
        setDetailedErr(
          "Password must be at least 8 characters long and contain at least one uppercase letter, one lowercase letter, one digit, and one special character."
        );
      } else if (password2 && password1 != password2) {
        setPasswordError1(true);
        setDetailedErr("Passwords don't match!");
      } else {
        setPasswordError1(false);
        setDetailedErr("");
        if (password1 === password2) {
          setSubmit(true);
        }
      }
    }
  }, [password1, password2]);

  // useEffect(() => {
  //   setSubmit(false);
  //   if (password2 != "") {
  //     if (password1 != password2) {
  //       setPasswordError1(true);
  //       setDetailedErr("Passwords don't match!");
  //     } else {
  //       setPasswordError1(false);
  //       setSubmit(true);
  //     }
  //   }
  // }, [password2]);

  useEffect(() => {
    // console.log("verificationCode=", verificationCode);
    const isEntered = verificationCode.every((digit) => digit.trim() !== "");
    // console.log("isEntered: " + isEntered);
    setVerificationCodeEntered(isEntered);
  }, [verificationCode]);

    function handleSubmit() {
      const newUser = {
        password: EncryptPassword(password1),
        verificationcode: JSON.stringify(verificationCode).replace(/[^0-9]/g, ''),
        username: email,
      };
      console.log("New User :: ", newUser);
      console.log(
        "Handle Submit :: ",
        password1,
        "verification :: ",
        verificationCode,
        "username :: ",
        email
      );
      dispatch(resetPasswordForgot(newUser));
    }


  // useEffect(() => {
  //   if (resetSuccess) {
  //     success = true;
  //     clearStore();
  //   } else {
  //     success = false;
  //   }
  // }, [resetSuccess]);

  useEffect(() => {
    setPassword1("");
    setPassword2("");
    if(resetError) {
      // setDetailedErr(resetError);
      console.log("reseterr", resetError);
      setTimeout(() => dispatch(clearStore()), 6000);
      ;
    }
  }, [resetError, dispatch]);

  // Handle success case
  useEffect(() => {
    if (resetSuccess) {
      console.log("Password reset successful:", resetSuccess);
      // Clear the form after successful reset
      setPassword1("");
      setPassword2("");
      setVerificationCode(['', '', '', '', '', '']);
    }
  }, [resetSuccess]);

  if (resetSuccess) {
    return (
      <Container fluid className="p-0">
        <Row className="no-gutters">
          <Col lg={5}>
            <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
              <div className="w-100">
                <Row className="justify-content-center">
                  <Col lg={9}>
                    <div>
                      <div className="text-center">
                        <div>
                          <Link to="/" className="logo">
                            <img src={logodark} height="60" alt="logo" />
                          </Link>
                        </div>
                        <h4 className="font-size-18 mt-5">Password Reset Successful!</h4>
                        <Alert color="success" className="mt-4">
                          {resetSuccess}
                        </Alert>
                      </div>
                      <div className="mt-5 text-center">
                        <p>
                          Return to{" "}
                          <Link
                            to="/login"
                            className="font-weight-medium text-primary"
                          >
                            {" "}
                            Login Page{" "}
                          </Link>{" "}
                        </p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
          <Col lg={7}>
            <div className="authentication-bg">
              {/* bg-overlay */}
              <div className=""></div>
            </div>
          </Col>
        </Row>
      </Container>
    );
  } else {
    return (
      <Container fluid className="p-0">
        <Row className="no-gutters">
          <Col lg={5}>
            <div className="authentication-page-content p-4 d-flex align-items-center min-vh-100">
              <div className="w-100">
                <Row className="justify-content-center">
                  <Col lg={9}>
                    <div>
                      <div className="text-center">
                        <div>
                          <Link to="/" className="logo">
                            <img src={logodark} height="60" alt="logo" />
                          </Link>
                        </div>
                        <h4 className="font-size-18 mt-5"></h4>
                        <p className="text-muted">
                          Reset your password to CloudNova License Manager!
                        </p>
                      </div>

                      <div>
                        <AvForm>
                          <div className="mt-4 text-center">
                            <p className="text-muted">
                              Enter verification code that you received on your
                              email account!
                            </p>
                            <div className="verification-form" style={{ display: 'flex', justifyContent: 'center', gap: '10px', marginBottom: '20px' }}>
                              {[0, 1, 2, 3, 4, 5].map((index) => (
                                <input
                                  key={index}
                                  type="text"
                                  maxLength="1"
                                  style={{
                                    width: '40px',
                                    height: '40px',
                                    textAlign: 'center',
                                    fontSize: '18px',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    outline: 'none'
                                  }}
                                  value={verificationCode[index]}
                                  onChange={(event) => handleDigitChange(index, event)}
                                  onKeyPress={(e) => {
                                    if (!/[0-9]/.test(e.key)) {
                                      e.preventDefault();
                                    }
                                  }}
                                  ref={(ref) => (verificationCodeRefs.current[index] = ref)}
                                />
                              ))}
                            </div>
                          </div>

                          <div className="mt-4 text-center">
                            <Label className="text-muted">
                              <p className="text-muted">Enter password</p>
                            </Label>
                            <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                              <AvField
                                name="password1"
                                type={showPassword1 ? "text" : "password"}
                                variant="outlined"
                                onChange={(e) => setPassword1(e.target.value)}
                                value={password1}
                                style={{ width: '100%' }}
                              />
                              <IconButton
                                onClick={handleClickShowPassword1}
                                onMouseDown={handleMouseDownPassword}
                                style={{
                                  position: 'absolute',
                                  right: '10px',
                                  top: '50%',
                                  transform: 'translateY(-50%)',
                                  zIndex: 1
                                }}
                              >
                                {showPassword1 ? <VisibilityIcon /> : <VisibilityOffIcon />}
                              </IconButton>
                            </div>
                          </div>

                          <div className="mt-4 text-center">
                            <Label className="text-muted">
                              Confirm your Password
                            </Label>
                            <div style={{ position: 'relative', display: 'inline-block', width: '100%' }}>
                              <AvField
                                name="password2"
                                type={showPassword2 ? "text" : "password"}
                                onChange={(e) => setPassword2(e.target.value)}
                                value={password2}
                                style={{ width: '100%' }}
                              />
                              <IconButton
                                onClick={handleClickShowPassword2}
                                onMouseDown={handleMouseDownPassword}
                                style={{
                                  position: 'absolute',
                                  right: '10px',
                                  top: '50%',
                                  transform: 'translateY(-50%)',
                                  zIndex: 1
                                }}
                              >
                                {showPassword2 ? <VisibilityIcon /> : <VisibilityOffIcon />}
                              </IconButton>
                            </div>
                          </div>
                        </AvForm>
                        
                        <div>
                          {passwordError1 ? (
                            <Alert color="danger" className="mt-4">
                              {detailedErr}
                            </Alert>
                          ) : null}
                          {resetError ? (
                            <Alert color="danger" className="mt-4">
                              {resetError}
                            </Alert>
                          ) : null}
                        </div>
                        <div className="mt-5 text-center">
                          <p>
                            <Button
                              color="primary"
                              className="w-md waves-effect waves-light"
                              onClick={() => handleSubmit()}
                              disabled={!verificationCodeEntered || !submit || loading}
                            >
                              {" "}
                              {loading ? "Resetting..." : "Reset Password!"}{" "}
                            </Button>{" "}
                          </p>
                        </div>
                      </div>
                      <div className="mt-5 text-center">
                        <p>
                          Return to{" "}
                          <Link
                            to="/login"
                            className="font-weight-medium text-primary"
                          >
                            {" "}
                            Login Page{" "}
                          </Link>{" "}
                        </p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
          <Col lg={7}>
            <div className="authentication-bg">
              {/* bg-overlay */}
              <div className=""></div>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
};

export default PasswordResetPage;